goVenue.checkBoxList = function(scope) {
    scope.checkboxlist = this;
    
    const saveField = scope.querySelector("input[type=hidden]");
    const checkboxes = Array.from(scope.querySelectorAll("input[type=checkbox]"));
    
    checkboxes.forEach(checkBox => {
        checkBox.addEventListener("change", () => {
            saveField.value = checkboxes
                .filter(x => x.checked)
                .map(x => x.value)
                .join(",");    
        });
    });
};

ControlBinders.register("[data-checkbox-list-container]", scope => new goVenue.checkBoxList(scope));